export default __webpack_public_path__ + "static/media/uy.091841c8.svg";